import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Validators, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { ToastrComponent } from '../util/toastr/toastr.component';
import { Misc } from '../util/misc';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { Projeto } from 'src/app/models/projeto.model';
import { ProjetoService } from 'src/app/services/projeto.service';
import { UtilService } from 'src/app/services/util.service';

@Component({
    selector: 'app-price-projeto-dialog',
    templateUrl: 'price-projeto-dialog.component.html',
    styleUrls: ['price-projeto-dialog.component.scss']
})

export class PriceProjetoDialogComponent {
    public keyUp = new Subject<Event>();

    projeto: Projeto;
    basicForm: UntypedFormGroup;

    defaultCrmId = 'P' + new Date().getFullYear() + '9999';

    constructor(public dialogRef: MatDialogRef<PriceProjetoDialogComponent>,
                protected projetoService: ProjetoService,
                private fb: UntypedFormBuilder,
                private toastr: ToastrComponent,
                private misc: Misc,
                public utilService: UtilService,
                @Inject(MAT_DIALOG_DATA) public data: any) {
        this.createForm();

        const subscription = this.keyUp.pipe(
            debounceTime(250)
        ).subscribe(result => {
            this.enterSave();
        });
    }

    createForm() {
        this.basicForm = this.fb.group({
            id: [0],
            nome: ['', Validators.required],
            crmId: [this.defaultCrmId, Validators.required],
            usuarioId: [this.utilService.getUserId()]
        });
    }

    enterSave() {
        if (!this.basicForm.valid) {
            return;
        }

        this.save();
    }

    save() {
        const projeto: Projeto = this.basicForm.value;
        projeto.clienteId = this.data.clienteId;

        if (projeto.crmId.length !== 9 || projeto.crmId === this.defaultCrmId) {
            this.toastr.mostrarMensagem('aviso', 'Atenção', 'Informe o CRM no formato ' + this.defaultCrmId);
            return;
        }

        this.projetoService.create(projeto)
            .subscribe(() => {
                this.close();
                this.toastr.mostrarMensagem('sucesso', 'Sucesso', 'Registro incluído com sucesso');
            }, err => {
                this.misc.processError(err, null);
            });
    }

    close(): void {
        this.dialogRef.close();
    }
}
